import QAOASimulator from "./QAOASimu";

function App() {
  return (
    <div className="App">
      <QAOASimulator />
    </div>
  );
}

export default App;

